import { Loader } from "./Loader";
import { Sampler } from "./Sampler";
import { SceneNode } from "./SceneNode";

export class Channel {

    public target: string;
    public sampler: Sampler;
    public frameCount: number;
    public targetNode: SceneNode;

    public loadBlob(dataView: DataView, loader: Loader) {
        let offset = 0;

        let samplerReference = dataView.getInt32(offset, true);
        offset += 4;

        this.sampler = loader.getBlob<Sampler>(samplerReference);

        let targetResult = loader.util.readString(dataView, offset);
        this.target = targetResult.string;
        offset = targetResult.offset;
    }
}

